import { aduanaService } from "@/_services";
export const aduana = {
  namespaced: true,
  state: {
    incoterms: {
      data: [],
      status: {},
    },
    postIncoterm: {
      data: {},
      status: {},
    },
    sendUps: {
      data: {},
      status: {},
    },
    sendFedex: {
      data: {},
      status: {},
    },
    deleteUps: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getIncotermsRequest(state) {
      state.incoterms.status = {
        loading: true,
      };
    },
    getIncotermsSuccess(state, response) {
      state.incoterms.data = response;
      state.incoterms.status = {
        loaded: true,
      };
    },
    getIncotermsError(state, error) {
      state.incoterms.data = null;
      state.incoterms.status = {
        error,
      };
    },
    postIncotermRequest(state) {
      state.postIncoterm.status = {
        loading: true,
      };
    },
    postIncotermSuccess(state, response) {
      state.postIncoterm.data = response;
      state.postIncoterm.status = {
        loaded: true,
      };
    },
    postIncotermError(state, error) {
      state.postIncoterm.data = null;
      state.postIncoterm.status = {
        error,
      };
    },
    sendUpsRequest(state) {
      state.sendUps.status = {
        sending: true,
      };
    },
    sendUpsSuccess(state, response) {
      state.sendUps.data = response;
      state.sendUps.status = {
        sended: true,
      };
    },
    sendUpsError(state, error) {
      state.sendUps.data = null;
      state.sendUps.status = {
        error,
      };
    },
    sendFedexRequest(state) {
      state.sendFedex.status = {
        sending: true,
      };
    },
    sendFedexSuccess(state, response) {
      state.sendFedex.data = response;
      state.sendFedex.status = {
        sended: true,
      };
    },
    sendFedexError(state, error) {
      state.sendFedex.data = null;
      state.sendFedex.status = {
        error,
      };
    },
    deleteUpsRequest(state) {
      state.deleteUps.status = {
        deleting: true,
      };
    },
    deleteUpsSuccess(state, response) {
      state.deleteUps.data = response;
      state.deleteUps.status = {
        deleted: true,
      };
    },
    deleteUpsError(state, error) {
      state.deleteUps.data = null;
      state.deleteUps.status = {
        error,
      };
    },
  },
  actions: {
    getIncoterms({ commit }, idEnvio) {
      commit("getIncotermsRequest");
      aduanaService
        .getIncoterms(idEnvio)
        .then((response) => {
          commit("getIncotermsSuccess", response);
        })
        .catch((error) => {
          commit("getIncotermsError", error);
        });
    },
    postIncoterm({ commit }, req) {
      commit("postIncotermRequest");
      aduanaService
        .postIncoterm(req)
        .then((response) => {
          commit("postIncotermSuccess", response);
        })
        .catch((error) => {
          commit("postIncotermError", error);
        });
    },
    sendToUps({ commit }, req) {
      commit("sendUpsRequest");
      aduanaService
        .sendToUps(req)
        .then((response) => {
          commit("sendUpsSuccess", response);
        })
        .catch((error) => {
          commit("sendUpsError", error);
        });
    },
    sendToFedex({ commit }, req) {
      commit("sendFedexRequest");
      aduanaService
        .sendToFedex(req)
        .then((response) => {
          commit("sendFedexSuccess", response);
        })
        .catch((error) => {
          commit("sendFedexError", error);
        });
    },
    deleteUps({ commit }, idFile) {
      commit("deleteUpsRequest");
      aduanaService
        .deleteUps(idFile)
        .then((response) => {
          commit("deleteUpsSuccess", response);
        })
        .catch((error) => {
          commit("deleteUpsError", error);
        });
    },
  },
};
